var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 257,
    viewBox: "0 0 218 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1907_70753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.032 215.671L157.188 257.001C157.188 257.001 65.974 170.339 54.6104 144.982C43.2467 119.626 64.6371 56.9023 64.6371 56.9023L112.097 82.926L155.032 215.671Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1723 39.5508L1.13484 40.8853C1.13484 40.8853 -6.21814 56.8999 16.5092 58.2344L15.1723 39.5508Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1723 64.2422L1.13484 65.5767C1.13484 65.5767 -6.21814 81.5913 16.5092 82.9258L15.1723 64.2422Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1723 90.9336L1.13484 92.2681C1.13484 92.2681 -6.21814 108.283 16.5092 109.617L15.1723 90.9336Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1821 117.621L5.1446 118.956C5.1446 118.956 -2.20838 134.97 20.519 136.305L19.1821 117.621Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33789 45.9856H9.40302V16.8582C9.40302 14.6443 9.83984 12.4522 10.6885 10.4068C11.5372 8.36151 12.7812 6.50308 14.3494 4.93765C15.9175 3.37222 17.7792 2.13046 19.8282 1.28326C21.8771 0.436055 24.0732 1.69615e-06 26.2909 0H88.1102C90.328 -4.52296e-06 92.524 0.436042 94.5729 1.28324C96.6219 2.13044 98.4836 3.3722 100.052 4.93762C101.62 6.50304 102.864 8.36146 103.713 10.4068C104.561 12.4521 104.998 14.6443 104.998 16.8581V176.653C104.998 178.867 104.561 181.059 103.713 183.105C102.864 185.15 101.62 187.009 100.052 188.574C98.4836 190.139 96.6219 191.381 94.573 192.228C92.5241 193.076 90.328 193.512 88.1103 193.512H26.291C21.812 193.512 17.5165 191.736 14.3494 188.574C11.1823 185.413 9.40305 181.125 9.40303 176.654V66.719H8.33789V45.9856Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6098 4.38673H33.6792C33.3081 5.29493 33.1665 6.28029 33.2667 7.25601C33.367 8.23173 33.7061 9.16786 34.2542 9.98194C34.8022 10.796 35.5425 11.4631 36.4096 11.9243C37.2768 12.3856 38.2442 12.6268 39.2268 12.6269H74.6423C75.6249 12.6268 76.5923 12.3856 77.4595 11.9243C78.3266 11.4631 79.0669 10.796 79.6149 9.98195C80.163 9.16787 80.5021 8.23173 80.6024 7.25601C80.7026 6.28029 80.561 5.29492 80.1899 4.38672H87.7268C91.0716 4.38672 94.2794 5.7131 96.6446 8.07408C99.0097 10.4351 100.338 13.6372 100.338 16.9762V176.537C100.338 178.19 100.012 179.827 99.3785 181.355C98.7447 182.882 97.8157 184.27 96.6446 185.439C95.4735 186.608 94.0832 187.536 92.5531 188.168C91.0229 188.801 89.383 189.127 87.7268 189.127H25.6098C23.9536 189.127 22.3136 188.801 20.7835 188.168C19.2533 187.536 17.863 186.608 16.6919 185.439C15.5208 184.27 14.5919 182.882 13.9581 181.355C13.3243 179.827 12.998 178.19 12.998 176.537V176.537V16.9762C12.998 15.3229 13.3243 13.6858 13.9581 12.1584C14.5919 10.631 15.5208 9.24314 16.6919 8.0741C17.863 6.90506 19.2533 5.97772 20.7835 5.34504C22.3136 4.71236 23.9536 4.38673 25.6098 4.38673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9763 49.0859H43.3594V55.4975H69.9763V49.0859Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.245 76.6367H42.0938V83.0483H71.245V76.6367Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1996 90.4102H24.1367V96.8217H89.1996V90.4102Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1996 104.184H24.1367V110.595H89.1996V104.184Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 237.195L143.181 151.987L140.507 97.2703L112.432 50.5612L104.411 30.543C104.411 30.543 85.694 32.5448 101.068 70.5794L107.419 90.9312C101.694 103.239 98.7288 116.645 98.7288 130.214V176.85C98.7288 187.831 151.152 247.647 157.254 256.784L218 237.195Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.612 54.5191L112.193 51.7809L112.003 51.3943L106.846 53.9245L99.061 33.5508L98.6582 33.7045L106.612 54.5191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.20964 40.6819L1.06055 41.0859L9.32865 44.1263L9.47774 43.7222L1.20964 40.6819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.20964 65.6546L1.06055 66.0586L9.32865 69.0989L9.47774 68.6949L1.20964 65.6546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.20964 92.346L1.06055 92.75L9.32865 95.7903L9.47774 95.3863L1.20964 92.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.54205 119.046L5.35547 119.434L9.38086 121.362L9.56744 120.974L5.54205 119.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7011 165.926C66.9981 165.926 75.3455 157.594 75.3455 147.315C75.3455 137.036 66.9981 128.703 56.7011 128.703C46.404 128.703 38.0566 137.036 38.0566 147.315C38.0566 157.594 46.404 165.926 56.7011 165.926Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9237 155.174L49.3438 148.011L52.5887 145.491L55.2308 148.883L64.1571 139.477L67.142 142.3L54.9237 155.174Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1907_70753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 257,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/message-sent.b3f994d8788f9d9236f80989512c0258.svg";
export { ForwardRef as ReactComponent };